/**
 * The nullable config booleans on `system_configuration` are edited through a
 * three-way select whose values are the strings 'true' | 'false' | 'null'
 * (see DEFAULT_BOOLEAN_OPTIONS_FOR_CONFIG). 'null' means "inherit": the
 * per-partner row, then the Movatic default. The API must receive a real
 * null for that, never the string, or the column would be written as false.
 */
export type ConfigOptionValue = 'true' | 'false' | 'null' | string;

export function configOptionToBoolean(
  value: ConfigOptionValue | undefined | null
): boolean | null {
  if (value === null || value === undefined || value === 'null') return null;
  return value === 'true';
}
